module.exports = __webpack_public_path__ + "img/UI_common_framelabelPF_01_2b64241fb.png";